import * as React from "react";
import type { SVGProps } from "react";

interface VideoReviewFailedProps extends SVGProps<SVGSVGElement> {
  cancelled?: boolean;
}
const VideoReviewFailed = ({ cancelled = false, ...props }: VideoReviewFailedProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <g>
    <g fill="none" fillRule="evenodd">
      <g transform="translate(2.25 2.25)">
        <circle
          cx={7.5}
          cy={7.5}
          r={8.57}
          fill="#FF1212"
          stroke="#FFF"
          strokeWidth={2.15}
        />
        <circle cx={7.5} cy={7.5} r={8.15} stroke="#000" strokeWidth={1.3} />
      </g>
      <path
        fill="#FFF"
        fillRule="nonzero"
        stroke="#FFF"
        strokeWidth={0.25}
        d="M12.43 6.14c.17 0 .34.06.48.2.24.24.36.45.4.63.07.24 0 .43-.15.57l-2.2 2.21 2.2 2.2a.67.67 0 0 1 0 .96c-.24.24-.45.36-.63.4a.57.57 0 0 1-.57-.15l-2.21-2.2-2.2 2.2a.67.67 0 0 1-.96 0 1.44 1.44 0 0 1-.4-.63.57.57 0 0 1 .15-.57l2.2-2.21-2.2-2.2a.67.67 0 0 1 0-.96c.27-.27.5-.4.7-.42l2.7 2.38 2.22-2.21c.13-.14.3-.2.47-.2Z"
      />
      <g transform="translate(9 16)">
        <rect
          width={14.75}
          height={7.75}
          x={-0.88}
          y={-0.88}
          fill="#FFF"
          stroke="#FFF"
          strokeWidth={1.75}
          rx={0.35}
        />
        <rect width={14} height={7} x={-0.5} y={-0.5} stroke="#000" rx={0.35} />
      </g>
      <path
        fill="#000"
        fillRule="nonzero"
        d="M11.75 21.35a.6.6 0 0 1-.32-.09.5.5 0 0 1-.2-.28l-1.24-3.73c-.05-.16-.05-.28 0-.37.06-.09.17-.13.35-.13.23 0 .38.12.46.35l.95 3.09.95-3.09c.08-.23.23-.35.48-.35.14 0 .25.04.3.13.07.1.07.21.02.37l-1.23 3.73a.5.5 0 0 1-.2.28c-.1.06-.21.1-.32.1Zm1.97-.02c-.13 0-.23-.04-.28-.12-.05-.09-.05-.2 0-.34l1.34-3.8c.08-.21.22-.32.44-.32h.06c.21 0 .36.1.43.32l1.34 3.8c.05.14.05.25 0 .34-.05.08-.14.12-.28.12h-.13c-.22 0-.36-.1-.43-.33l-.18-.58h-1.59l-.18.58c-.07.22-.21.33-.43.33zm.98-1.7h1.07l-.53-1.66-.54 1.67Zm3.38 1.7c-.26 0-.4-.14-.4-.43v-3.72c0-.29.14-.43.4-.43h1.6c.27 0 .5.04.7.13s.36.23.47.43c.1.2.16.46.16.79 0 .4-.08.72-.25.92-.17.21-.4.34-.69.4l.64 1.4c.07.15.09.27.04.37-.04.1-.13.14-.27.14h-.12c-.23 0-.39-.1-.48-.33l-.63-1.54h-.77v1.44c0 .29-.13.43-.4.43m.4-2.66h1.09c.18 0 .33-.05.43-.13.11-.09.16-.24.16-.44s-.05-.35-.16-.43a.67.67 0 0 0-.43-.13h-1.09z"
      />
    </g>
        {cancelled && (
        <rect
          width="25"
          height="2.5"
          x="-.494"
          y="10.746"
          fill="#000"
          fillRule="evenodd"
          stroke="#FFF"
          rx="1"
          transform="rotate(-45 12.006 11.996)"
        />
      )}
    </g>
  </svg>
);
export default VideoReviewFailed;
